import React from 'react'

import { withTheme } from 'modules/util'

import layoutTheme from './theme.scss'

export function Layout({ children, theme }) {
  return (
    <div className={theme.app}>
      <div className={theme.main}>
        {children}
      </div>
    </div>
  )
}

export default withTheme(layoutTheme, Layout)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Main/Layout/index.js